import React from 'react'
import { Link } from 'react-router-dom'

import { about, footerSocial, landing,location } from '../data'

import logoLight from '../assets/images/logo-light.png'
import logoDark from '../assets/images/logo-dark.png'

export default function FooterLight() {
  return (
    <>
      <footer className="footer bg-light">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
                        <Link className="logo-footer text-light" to="#"><img src={logoLight} height="28" className="footer-logo-light" alt=""/></Link>
                        <Link className="logo-footer text-light" to="#"><img src={logoDark} className="footer-logo-dark" height="28" alt=""/></Link>

                        <p className="mt-4 text-muted mb-0">Helping global companies launch and grow in India with expert services in compliance, tech, and AI-driven operations.</p>
                    </div>
                    
                    <div className="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <h4 className="footer-head text-dark">Landing</h4>
                        <ul className="list-unstyled footer-list mt-4">
                            {landing.map((item,index)=>{
                                return(
                                    <li key={index}><Link to="#" className="text-foot text-muted"><i className="mdi mdi-chevron-right me-1"></i> {item}</Link></li>
                                )
                            })}
                        </ul>
                    </div>

                    <div className="col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <h4 className="footer-head text-dark">About</h4>
                        <ul className="list-unstyled footer-list mt-4">
                            {about.map((item,index)=>{
                                return(
                                    <li key={index}><Link to="#" className="text-foot text-muted"><i className="mdi mdi-chevron-right me-1"></i> {item}</Link></li>
                                )
                            })}
                        </ul>
                    </div>

                    <div className="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <h4 className="footer-head text-dark">Locations</h4>
                        <ul className="list-unstyled footer-list mt-4">
                            {location.map((item,index)=>{
                                return(
                                    <li key={index}><Link to="#" className="text-foot text-muted"><i className="mdi mdi-chevron-right me-1"></i> {item}</Link></li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </footer>

        <footer className="footer bg-white border-top footer-bar">
            <div className="container text-center">
                <div className="row align-items-center">
                    <div className="col-sm-6">
                        <div className="text-sm-start">
                            <p className="mb-0">© {new Date().getFullYear()} <span className="text-reset">Pioneer One Global</span>. </p>
                        </div>
                    </div>

                    <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <ul className="list-unstyled text-sm-end social-icon mb-0">
                            {footerSocial.map((item,index)=>{
                                let Icon = item.icon
                                return(
                                    <li className="list-inline-item m-x-2" key={index}><Link to={item.link} target="_blank" className="rounded"><i className="align-middle" title="Buy Now"><Icon/></i></Link></li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </>
  )
}
